import {DetailMissingInputError} from '../errors/InputErrors';

const MISSING_FIELD = /Variable "\$(.*)" of required type .* was not provided\./;
const MISSING_FIELD_MONGOOSE = /.*validation failed: .*: Path `(.*)` is required\./;
const DUPLICATE_ENTRY_MONGOOSE = `duplicate key error`;
export default ({graphQLErrors, networkError, t}) => {
  let errorMessages = [];
  if (graphQLErrors) {
    errorMessages = graphQLErrors.reduce((result, {message, ...rest}, i, {length}) => {
      if (message) {
      }
      let missingFields = MISSING_FIELD.exec(message);
      if (!missingFields) {
        missingFields = MISSING_FIELD_MONGOOSE.exec(message);
      }
      if (missingFields) {
        let field = convertMissingField(missingFields[1]);
        result.push(DetailMissingInputError(field, t));
      } else if (message.toLowerCase().includes(DUPLICATE_ENTRY_MONGOOSE)) {
        result.push({message: t('clientError.existingError')});
      } else {
        result.push(t(message));
      }
      return result;
    }, errorMessages);
  }

  if (networkError) {
    errorMessages.push({message: t('clientError.connectionError')});
  }

  return errorMessages;
};

function convertMissingField(field) {
  switch (field) {
    case 'loginName':
      return 'Login Name';
    case 'loginToken':
      return 'Login Token';
    case 'name':
      return 'Name';
    default:
      return field;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/errorHelper.js